export default function SessionStorageProvider() {
  this.$get = () => {
    'ngInject';

    function SessionStorageProvider() {

      const self = this;

      self.tryToSet = (key, value) => {
        if (value === undefined) {
          return;
        }

        try {
          sessionStorage[key] = JSON.stringify(value);
        } catch (e) {
          throw e;
        }
      };

      self.tryToRemove = (key) => {
        try {
          delete sessionStorage[key];
        } catch (e) {
          throw e;
        }
      };

      self.set = (key, value) => {
        if (isSupported() && value !== undefined) {
          sessionStorage[key] = JSON.stringify(value);
        }
      };

      self.get = (key) => {
        if (isSupported() && sessionStorage[key] !== undefined) {
          return parseValue(key);
        }

        return null;
      };

      self.remove = (key) => {
        if (isExists(key)) {
          delete sessionStorage[key];
        }
      };

      const isSupported = () => {
        try {
          return 'sessionStorage' in window && window.sessionStorage !== null;
        } catch (e) {
          return false;
        }
      };

      const isExists = (key) => {
        if (isSupported()) {
          return !!sessionStorage[key];
        }

        return false;
      };

      function parseValue(key) {
        try {
          return JSON.parse(sessionStorage[key]);
        } catch (e) {
          return sessionStorage[key];
        }
      }
    }

    return new SessionStorageProvider();
  };
}